import * as types from "./mutation-types.js";

export const mutations = {
  [types.SET_BETALINGEN](state, list) {
    state.betalingenInfo = list;
  },
  [types.SET_CURSIST_INFO](state, cursist) {
    state.cursistInfo = cursist;
  },
  [types.ZET_CURRENT_OPLEIDING](state, opleiding) {
    state.currentOpleiding = opleiding;
  },
  [types.SET_OPLEIDING_LIST](state, opleiding) {
    state.opleidingList = opleiding;
  },
  [types.SET_GEVOLGDEOPLEIDING_LIST](state, gevolgdeopleiding) {
    // state.gevolgdeopleidingOpleidingList = gevolgdeopleiding;
    state.gevolgdeopleidingOpleidingList = gevolgdeopleiding.map(s => {
      s.colorReference = 'bg-light'

      return s;
    })
  },
  [types.SET_MODULE_LIST](state, modules) {
    // state.moduleList = modules;
    state.moduleList = modules.map(s => {
      if (s.hasOwnProperty("Atype") && s.hasOwnProperty("Resultaat")) {
        if (s.Atype === 'VRIJSTELLING' || s.Resultaat === 'GESLAAGD') {
          s.colorReference = 'alert-success'

        }
        else if (s.Resultaat === 'NT_GESLAAGD' || s.Resultaat === 'NT_DEELGENOMEN') {
          s.colorReference = 'alert-danger'

        }
        else if (s.Resultaat === '?') {// Aan het volgen
          s.colorReference = 'alert-warning'

        }

      } else {
        s.colorReference = 'bg-light'
      }

      // if ( s.hasOwnProperty("LESDatum") )
      // {

      //    s.taskName = s.LESDatum;
      //    delete s.LESDatum;   
      // }
      return s;
    })
  },
  // [types.SET_RAW_PARTICIPATION_LIST](state, participations) {
  //   state.uneditedParticipations = participations

  // },
  [types.SET_PARTICIPATION_LIST](state, participations) {
    let val = function () {
      if (window.innerWidth <= 600) {
        return "1.6rem"
      } else {
        return "16px"
      }
    }
    //This is used to change the most inner value to taskName so teh Tree grid can dispaly it.
    let temp = JSON.parse(JSON.stringify(participations))
    let renamedKey = temp.map(s => {
      s.Klasomschrijving = '[' + s.SchooljaarRange + ']' + ' ' + s.Klasomschrijving
      s.LESDatum = moment(s.LESDatum, 'DD/MM/YYYY').format("YYYY-MM-DD") + '  /  ' + moment(s.LESVANUUR, 'H:mm:ss').format("HH:mm") + '-' + moment(s.LESTOTUUR, 'H:mm:ss').format("HH:mm")
      if (s.ParticipatieOmschrijving === '') {
        s.ParticipatieOmschrijving = 'Nog niet ingevuld'
        s.ParticipatieColor = "dedede"
      }
      if (s.ParticipatieOmschrijving === 'Afstandsles') {
        // s.ParticipatieOmschrijving = 'Afstandsles'
        s.ParticipatieColor = "17a2b8" //bg-info color
      }
      if (s.ParticipatieOmschrijving === 'Vervallen Les') {
        // s.ParticipatieOmschrijving = 'Vervallen Les'
        s.ParticipatieColor = "dedede" //bg-danger color
      }
      if (s.hasOwnProperty("LESDatum")) {

        s.taskName = s.LESDatum;
        delete s.LESDatum;
      }
      return s;
    })
    //https://stackoverflow.com/questions/61610032/flat-array-restructure-to-a-tree-array/61610506#61610506
    //re structuring data to make the tree grid work
    let data = renamedKey,
      groups = [["Klasomschrijving"], ["Moduleomschrijving", "ModuleID"], ["ParticipatieOmschrijving"]],
      result = data.reduce((r, o) => {
        groups
          .reduce((p, [key, ...levelKeys]) => {
            let taskName, temp;
            ({ [key]: taskName, ...o } = o);
            temp = p.find(q => q.taskName === taskName);
            if (!temp) {
              let moreProps = levelKeys.reduce((t, k) => {
                let value;
                ({ [k]: value, ...o } = o);
                return { ...t, [k]: value };
              }, {});
              p.push((temp = { ...moreProps, taskName, subtasks: [] }));
            }
            return temp.subtasks;
          }, r)
          .push(o);
        return r;
      }, []);
    //add extra field for total value of codes in particiaptions
    result.map(function (entry) {
      for (let y = 0; y < entry.subtasks.length; y++) {
        for (let i = 0; i < entry.subtasks[y].subtasks.length; i++) {
          entry.subtasks[y].subtasks[i].total = entry.subtasks[y].subtasks[i].subtasks.length
          entry.subtasks[y].startdatum = moment(entry.subtasks[y].subtasks[i].subtasks[0].IngModuleVariantVan, 'DD/MM/YYYY').format("YYYY-MM-DD")
          entry.startdatum = moment(entry.subtasks[y].subtasks[i].subtasks[0].KlasVan, 'DD/MM/YYYY').format("YYYY-MM-DD")
          entry.subtasks[y].subtasks[i].color = entry.subtasks[y].subtasks[i].subtasks[0].ParticipatieColor
        }
      }
      return entry;
    });

    // state.participationList = Object.values(custommodifier(participations))
    state.participationList = result
    participations.forEach(function (data) {
      let isPartipEmpty = function () {
        if (data['ParticipatieOmschrijving'] === '') {
          return "none"
        } else {
          return "block"
        }
      }

      data['Subject'] = data['Moduleomschrijving'];
      // delete data['Moduleomschrijving'];
      data['StartTime'] = moment(data.LESDatum + ' ' + data.LESVANUUR, 'DD/MM/YYYY HH:mm:ss');
      data['EndTime'] = moment(data.LESDatum + ' ' + data.LESTOTUUR, 'DD/MM/YYYY HH:mm:ss');
      if (data['Buitenschoolseactiviteit'] === 'True') {
        data['Location'] = 'Buitenschoolse activiteit'
      } else {
        data['Location'] = data['ParticipatieOmschrijving'] === 'Afstandsles' ? data.ParticipatieOmschrijving + '<br>' + data.LokaalOmschrijving + ' ' + 'Lokaal ' + data.LokaalCode + '<br> ' + data.LesPlaatsOmschrijving + '<br>' + data.LesPlaatsStraat + ' ' + data.LesPlaatsStraatNr + ' ' + data.LesPlaatsStraatBus + '<br>' + data.LesPlaatsDeelgemeente : data.LokaalOmschrijving + ' ' + 'Lokaal ' + data.LokaalCode + '<br> ' + data.LesPlaatsOmschrijving + '<br>' + data.LesPlaatsStraat + ' ' + data.LesPlaatsStraatNr + ' ' + data.LesPlaatsStraatBus + '<br>' + data.LesPlaatsDeelgemeente;
      }
      data['Description'] = data.LeerkrachtVoornaam + ' ' + data.LeerkrachtNaam + '<br>'
        + '<div  style="padding-top:10px"><i style="position:absolute;left:' + val() + ';padding-top:2px;display:' + isPartipEmpty() + '" class="far fa-check-double"></i>' + data.ParticipatieOmschrijving + '</div>'
      data['IsReadonly'] = true;
    })
    let earliestHour = participations.map(d => {
      return moment(d.LESVANUUR, "HH:mm:ss").startOf('hour').format('HH:mm')
    })
    let latestHour = participations.map(d => {
      return moment(d.LESTOTUUR, "HH:mm:ss").endOf('hour').format('HH:mm')
    })

    state.earliestHour = _.minBy(earliestHour);
    state.latestHour = _.maxBy(latestHour);
    // let g = Math.min(a)
    state.participationListCalendar = JSON.parse(JSON.stringify(participations))
    // self.participationList = JSON.parse(JSON.stringify(result))
  },
  [types.GET_LEERLING_GENERAL](state, leerling) {
    state.leerling = leerling;
  },
  [types.SET_ACCOUNT_INFO](state, payload) {
    state.accountInformation.gebruikersnummer = payload.data.rows[0].U_ID;
    state.accountInformation.lastlogin = payload.data.rows[0].U_LAATSTELOGOUT;
    state.accountInformation.gebruikersnaam = payload.data.rows[0].U_NAAM;
    state.accountInformation.fullname = payload.data.rows[0].U_NAAMVOLLEDIG;
  },
  [types.ZET_CURRENT_SCREEN](state, groep) {
    state.currentScreen = groep;
  },
  [types.SET_STATE_TO_INITIAL_VALUES](state) {
    let init = JSON.parse(JSON.stringify(state.initialValues));
    for (var property in init) {
      if (init.hasOwnProperty(property)) {
        state[property] = init[property];
      }
    }
  }
};
